import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    loginModal_title: 'Авторизация',
    loginPage_labelLogin: 'Логин',
    loginPage_placeholderLogin: 'Введите ваш логин',
    loginPage_labelPassword: 'Пароль',
    loginPage_placeholderPassword: 'Введите ваш пароль',
    loginPage_loginWithECP: 'Войти с ЭЦП',
    loginPage_login: 'Войти',

    //integration modal
    loginPage_integration_VALID: 'Данные получены успешно',
    loginPage_integration_INVALID: 'Вы отказали в доступе личных данных',
    loginPage_integration_TIMEOUT: 'Ошибка при получении данных',
    loginPage_integration_PENDING: 'В ожидание ответа на смс',
    loginPage_integration_NOT_FOUND: 'По вашему ИИН данные не найдены в сервисе КДП',
    loginPage_integration_status: 'Статус проверки персональных данных',
    loginPage_integration_REJECT:
      'Вы отказались от сбора и обработки персональных данных. Без согласия работа на портале невозможна',

    loginDucks_authError: 'Не удалось авторизоваться',
    loginDucks_incorrectUsernamePassword: 'Введен неверный логин или пароль',
    loginDucks_userNotFound: 'Пользователь не найден в системе',
    loginDucks_signatureVerificationFail:
      'Ошибка ЭЦП, сертификат просрочен или некорректная подпись',
    loginDucks_userNotActive: 'Пользователь не активирован',
    loginPage_disclaimer:
      'Уведомление об ответственности Я, пользователь портала электронных услуг Beyim Smart QR, продолжаю работу, подтверждаю свое согласие на передачу своих персональных данных для их обработки, в соответствии с Законом РК "О персональных данных и их защите"'
  },
  kk: {
    loginModal_title: 'Авторизация',
    loginPage_labelLogin: 'Логин',
    loginPage_placeholderLogin: 'Введите ваш логин',
    loginPage_labelPassword: 'Пароль',
    loginPage_placeholderPassword: 'Введите ваш пароль',
    loginPage_loginWithECP: 'ЭЦҚ арқылы кіру',
    loginPage_login: 'Войти',

    //integration modal
    loginPage_integration_VALID: 'Деректер сәтті алынды',
    loginPage_integration_INVALID: 'Сіз жеке деректерге қол жеткізуден бас тарттыңыз',
    loginPage_integration_TIMEOUT: 'Деректерді қабылдау кезінде қате',
    loginPage_integration_NOT_FOUND: 'Сіздің ЖСН бойынша ҚДП сервисінде деректер табылмады.',
    loginPage_integration_PENDING: 'SMS — ке жауап күтуде',
    loginPage_integration_status: 'Жеке деректерді тексеру мәртебесі',
    loginPage_integration_REJECT:
      'Сіз деректерді жинауға және өңдеуге келісім бермедіңіз. Келісімсіз порталда жұмыс жасау мүмкін емес.',

    loginDucks_authError: 'Авторизациядан  өту мүмкін емес',
    loginDucks_incorrectUsernamePassword: 'Логин немесе құпия сөз қате енгізілді',
    loginDucks_userNotFound: 'Пайдаланушы жүйеде табылмады',
    loginDucks_signatureVerificationFail:
      'ЭЦҚ қатесі, сертификат мерзімі өткен немесе қол қате',
    loginDucks_userNotActive: 'Пользователь не активирован',
    loginPage_disclaimer:  
  'Жауапкершілік туралы хабарлама Мен, Beyim Smart QR электрондық қызметтер порталының пайдаланушысы, жұмысты жалғастыра отырып, өзімнің жеке деректерімді өңдеу үшін беруге келісімімді растаймын, бұл ҚР "Жеке деректер және оларды қорғау туралы" Заңына сәйкес жүзеге асырылады'
  }
});
